import type { RootState } from 'js/src/libs/RootState';

function getPremiumMediaStatus(state: RootState) {
    return state.premium_media;
}

export function getUnusedCreditCount(state: RootState) {
    return getTotalActiveCreditAvailability(state) - getTotalActiveCreditExpense(state);
}

export function getTotalActiveCreditAvailability(state: RootState) {
    return getPremiumMediaStatus(state).total_active_credit_availability;
}

export function getTotalActiveCreditExpense(state: RootState) {
    return getPremiumMediaStatus(state).total_active_credit_expense;
}
